import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/home',
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/manager/Home') },
      { path: 'admin', name: 'Admin', meta: { name: '管理用户信息' }, component: () => import('../views/manager/Admin') },
      { path: 'campus', name: 'Campus', meta: { name: '校区管理' }, component: () => import('../views/manager/Campus') },
      { path: 'teacher', name: 'Teacher', meta: { name: '教师信息' }, component: () => import('../views/manager/Teacher') },
      { path: 'student', name: 'Student', meta: { name: '学生信息' }, component: () => import('../views/manager/Student') },
      { path: 'clazz', name: 'Clazz', meta: { name: '班级管理' }, component: () => import('../views/manager/Clazz') },
      { path: 'homeworkSubject', name: 'HomeworkSubject', meta: { name: '作业科目管理' }, component: () => import('../views/manager/HomeworkSubject') },
      { path: 'studentGrade', name: 'StudentGrade', meta: { name: '学生年级管理' }, component: () => import('../views/manager/StudentGrade') },
      { path: 'notice', name: 'Notice', meta: { name: '公告管理' }, component: () => import('../views/manager/Notice') },
      { path: 'feedback', name: 'Feedback', meta: { name: '意见反馈' }, component: () => import('../views/manager/Feedback') },
      { path: 'homeBanner', name: 'HomeBanner', meta: { name: 'Banner 管理' }, component: () => import('../views/manager/HomeBanner') },
      { path: 'adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') }
    ]
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '*', name: 'NotFound', meta: { name: '未找到' }, component: () => import('../views/404.vue') }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
